module.exports = __webpack_public_path__ + "assets/img/logo_auc_pos.09015614.png";